import { bootstrapApp } from '@backoffice-frontend/authenticated-app-view'
import { App } from './lib/App'

bootstrapApp(App)
